import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getFolder = async (folderId, query) => {
  const folder = await request(getEndpoint("folder", "getFolder", folderId), {
    query,
  });
  return folder.data;
};
export const createFolder = async (payload) => {
  const folder = await request(getEndpoint("folder", "createFolder"), {
    body: payload,
  });
  return folder.data;
};
export const updateFolder = async (folderId, payload) => {
  const folder = await request(
    getEndpoint("folder", "updateFolder", folderId),
    {
      body: payload,
    },
  );
  return folder.data;
};
export const deleteFolder = async (folderId) => {
  const folder = await request(getEndpoint("folder", "deleteFolder", folderId));
  return folder.data;
};

export const resolveFolderPath = async (query) => {
  const path = await request(getEndpoint("folder", "resolvePath"), {
    query,
  });
  return path.data;
};

export const addItemToFolder = async (folderId, payload) => {
  const result = await request(getEndpoint("folder", "addItem", folderId), {
    body: payload,
  });
  return result.data;
};

export const removeItemFromFolder = async (folderId, folderEntryId) => {
  const result = await request(
    getEndpoint("folder", "removeItem", folderId, folderEntryId),
  );
  return result.data;
};
export const reorderItems = async (folderId, payload) => {
  const result = await request(
    getEndpoint("folder", "reorderItems", folderId),
    { body: payload },
  );
  return result.data;
};
